export const fromParamUtils = (url: string | null): string | null => {
    if (!url) return null;

    const urlObj = new URL(url);
    return urlObj.searchParams.get('from');
};

// check if the job is from mobweb hp, react-native app hp or desktop hp
export const isJobFromHomePage = (from: string | undefined | null): boolean => {
    // from can be hp for viewJobLink url and hp.* or hpd.* for the viewJob url after the job click redirect
    return from?.startsWith('hp') ?? false;
};

// check if the job is from serp
export const isJobFromSerp = (from: string | undefined | null): boolean => {
    return (from?.startsWith('serp') || from?.startsWith('tp-serp')) ?? false;
};
